import { render, staticRenderFns } from "./redeemThePrizeList.vue?vue&type=template&id=54460671&scoped=true&"
import script from "./redeemThePrizeList.vue?vue&type=script&lang=js&"
export * from "./redeemThePrizeList.vue?vue&type=script&lang=js&"
import style0 from "./redeemThePrizeList.vue?vue&type=style&index=0&id=54460671&lang=less&scoped=true&"
import style1 from "./redeemThePrizeList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54460671",
  null
  
)

export default component.exports